const PRIZE_TYPE_LABELS: Record<string, string> = {
  '3_DIGIT_TOP': '3 ตัวบน',
  '3_DIGIT_BOTTOM': '3 ตัวล่าง',
  '3_DIGIT_TOD': '3 ตัวโต๊ด',
  '3_DIGIT_REVERSE': '3 ตัวบน (กลับเลข)',
  '2_DIGIT_TOP': '2 ตัวบน',
  '2_DIGIT_BOTTOM': '2 ตัวล่าง',
  '2_DIGIT_TOD': '2 ตัวโต๊ด',
  'RUNNING_TOP': 'วิ่งบน',
  'RUNNING_BOTTOM': 'วิ่งล่าง',
  '4_DIGIT_TOP': '4 ตัวบน',
  '4_DIGIT_TOD': '4 ตัวโต๊ด',
  '5_DIGIT_TOD': '5 ตัวโต๊ด',
  'FIXED_POSITION_ONES': 'ปักหลักหน่วย',
  'FIXED_POSITION_TENS': 'ปักหลักสิบ',
  'FIXED_POSITION_HUNDREDS': 'ปักหลักร้อย',
  'FIRST_PRIZE': 'รางวัลที่ 1',
  'SECOND_PRIZE': 'รางวัลที่ 2',
  'THIRD_PRIZE': 'รางวัลที่ 3',
  'REVERSE_2_DIGIT': '+2 กลับ',
  'REVERSE_3_DIGIT': '+3 กลับ',
  'TONG_PRIZE': '+ ทอง',
}

export function resolvePrizeTypeLabel(prizeTypeCode?: string, prizeTypeName?: string): string {
  const explicitName = String(prizeTypeName || '').trim()
  if (explicitName) return explicitName

  const normalizedCode = String(prizeTypeCode || '').trim().toUpperCase()
  if (!normalizedCode) return ''

  return PRIZE_TYPE_LABELS[normalizedCode] || normalizedCode.replace(/_/g, ' ')
}
